<template>
  <div>
    <wc-page-title :loading='isLoading' :title='title' :subtitle='subtitle'></wc-page-title>
    <router-view
      v-if='project'
      :project='project'
      @update='update'
      @updateProject='updateProject'
    ></router-view>
  </div>
</template>

<script>
import projectsAPI from '@/modules/projects/api/projects'
import constructionAPI from '@/modules/construction/api/construction'
import { mapState } from 'vuex'

export default {
  name: 'construction-project-base',
  data: () => ({
    isLoading: true,
    project: null
  }),
  computed: {
    title () {
      if (this.project) {
        return this.project.name
      }
      return ''
    },
    subtitle () {
      if (this.project) {
        return this.project.site_address
      }
      return ''
    },
    menu () {
      return [
        {
          title: this.overview.title,
          icon: this.overview.icon,
          route: { name: 'ConstructionOverview', params: { id: this.$route.params.id } }
        },
        {
          title: this.workorders.title,
          icon: this.workorders.icon,
          route: { name: 'ConstructionProjectWOs', params: { id: this.$route.params.id } }
        },
        {
          title: this.invoices.title,
          icon: this.invoices.icon,
          route: { name: 'ConstructionProjectInvoices', params: { id: this.$route.params.id } }
        },
        {
          title: 'Estimates (coming soon)',
          icon: this.estimates.icon,
          // route: { name: 'ConstructionEstimates', params: { id: this.$route.params.id } }
        },
        {
          title: 'Timesheet Details',
          icon: this.$store.state.icons.modules.timesheets.icon,
          route: { name: 'ConstructionTimesheetDetails', params: { id: this.$route.params.id } }
        },
        {
          title: 'Reports',
          icon: "mdi-chart-bar",
          route: { name: 'ConstructionReports', params: { id: this.$route.params.id } }
        },
        {
          title: this.actionTracker.title,
          icon: this.actionTracker.icon,
          route: { name: 'ConstructionActionTracker', params: { id: this.$route.params.id } }
        },
        {
          title: this.crewVisits.title,
          icon: this.crewVisits.icon,
          route: { name: 'ConstructionCrewVisits', params: { id: this.$route.params.id } }
        }
      ]
    },
    ...mapState({
      overview: state => state.icons.routes.overview,
      actionTracker: state => state.icons.routes.actionTracker,
      workorders: state => state.icons.modules.workorders,
      invoices: state => state.icons.dataBox.invoices,
      crewVisits: state => state.icons.dataBox.crewVisits,
      estimates: state => state.icons.modules.estimates
    })
  },
  mounted () {
    this.getProject()
  },
  methods: {
    async getProject () {
      this.isLoading
      this.project = await projectsAPI.getProject(this.$route.params.id)
      this.$store.dispatch('loadSubnavTitle', 'Project Menu')
      this.$store.dispatch('loadSubnav', this.menu)
      this.isLoading = false
    },
    async update (project) {
      this.isLoading = true
      await constructionAPI.updateConstructionProject(project.project_detail)
      this.project = await projectsAPI.updateProject(project)
      this.isLoading = false
    },
    updateProject(project) {
      // this is primarily for the timesheet details update, so each routerview layer keep it's project object in sync.
      this.project = project
    }
  }
}
</script>